"use client"

import { useState } from "react"
import { TranslateButton } from "@/components/TranslateButton"

/**
 * Wraps a block of text with an optional translate button.
 * When translated, shows the translated text; when toggled back, shows original.
 */
export function TranslatableText({
  text,
  className,
}: {
  text: string
  className?: string
}) {
  const [translated, setTranslated] = useState<string | null>(null)

  return (
    <div>
      <div className={className}>
        {translated ?? text}
      </div>
      <div className="mt-2">
        <TranslateButton text={text} onTranslated={setTranslated} />
      </div>
    </div>
  )
}
